type ProductResourcesCardContainerHeaderProps = {
	children: React.ReactNode
}

export default function ProductResourcesCardContainerHeader({
	children,
}: ProductResourcesCardContainerHeaderProps) {
	return (
		<div className="flex w-full px-4 mb-2 gap-5 items-center justify-center text-xs text-gray-900 font-medium">
			{children}
		</div>
	)
}
